import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'GameCard',
  props: {
    game: Object,
    isSelected: Boolean,
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`wrapper ${__props.isSelected ? 'selected' : ''}`)
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle(`background-image: url('/assets/images/game-thumbnails/${__props.game!.src}.webp');'`),
      class: "thumbnail"
    }, null, 4)
  ], 2))
}
}

})